import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/higherEducation.jpg';

function HigherEducation() {
  const [Faq, setFaq] = useState(0); // first dropdown open by default
  const titleRef = useRef(null);
  const [titleColor, setTitleColor] = useState('');

  useEffect(() => {
    if (titleRef.current) {
      const c = window.getComputedStyle(titleRef.current).color;
      setTitleColor(c);
    }
  }, []);

  // shared inline styles
  const liRow = { display: 'flex', alignItems: 'flex-start', gap: '10px', marginBottom: '12px' };
  const icon = { marginTop: '4px', flex: '0 0 auto' };
  const kv = { display: 'flex', flexDirection: 'column', gap: '4px', flex: 1, minWidth: 0 };
  const keyText = { fontWeight: 700, fontSize: '1.1rem', lineHeight: 1.35, color: '#0f172a' };
  const valText = { fontSize: '1rem', lineHeight: 1.6, color: '#334155' };
  const overviewText = { color: titleColor || '#0f172a', fontSize: '1.05rem', lineHeight: 1.6, margin: '8px 0 16px' };

  const sections = [
    {
      Que: 'Admissions & Eligibility',
      Answer: (
        <ul className="list-unstyled list-style">
          {[
            ['Undergraduate:', 'High school diploma/GED, minimum GPA; test-optional where applicable.'],
            ['Graduate:', 'Bachelor’s from an accredited institution and program prerequisites.'],
            ['Transfer:', 'Minimum transferable credits and GPA; official transcripts for evaluation.'],
          ].map(([k, v], i) => (
            <li key={`admit-${i}`} style={liRow}>
              <i className="fa-solid fa-circle-arrow-right" style={icon} />
              <div style={kv}><span style={keyText}>{k}</span><span style={valText}>{v}</span></div>
            </li>
          ))}
        </ul>
      ),
    },
    {
      Que: 'Degrees & Programs',
      Answer: (
        <ul className="list-unstyled list-style">
          {[
            ['Bachelor’s options:', 'Wide range of majors/minors across arts, sciences, and professional studies.'],
            ['Graduate study:', 'Master’s, doctoral, and graduate certificates with research or practice tracks.'],
            ['Modalities:', 'On-campus, online, and hybrid offerings for flexible schedules.'],
          ].map(([k, v], i) => (
            <li key={`programs-${i}`} style={liRow}>
              <i className="fa-solid fa-circle-arrow-right" style={icon} />
              <div style={kv}><span style={keyText}>{k}</span><span style={valText}>{v}</span></div>
            </li>
          ))}
        </ul>
      ),
    },
    {
      Que: 'Advising & Registration',
      Answer: (
        <ul className="list-unstyled list-style">
          {[
            ['Assigned advisor:', 'Academic planning from orientation to graduation.'],
            ['Degree audits:', 'Track requirements and progress toward completion.'],
            ['Enrollment:', 'Registration windows, add/drop deadlines, and waitlists managed in the student portal.'],
          ].map(([k, v], i) => (
            <li key={`advising-${i}`} style={liRow}>
              <i className="fa-solid fa-circle-arrow-right" style={icon} />
              <div style={kv}><span style={keyText}>{k}</span><span style={valText}>{v}</span></div>
            </li>
          ))}
        </ul>
      ),
    },
    {
      Que: 'Tuition, Aid & Scholarships',
      Answer: (
        <ul className="list-unstyled list-style">
          {[
            ['Cost & billing:', 'Per-credit tuition, mandatory fees, and payment plans.'],
            ['Financial aid:', 'Grants, loans, work-study; merit and need-based scholarships.'],
            ['Deadlines:', 'FAFSA and institutional applications due before priority dates each term.'],
          ].map(([k, v], i) => (
            <li key={`aid-${i}`} style={liRow}>
              <i className="fa-solid fa-circle-arrow-right" style={icon} />
              <div style={kv}><span style={keyText}>{k}</span><span style={valText}>{v}</span></div>
            </li>
          ))}
        </ul>
      ),
    },
    {
      Que: 'Student Services & Supports',
      Answer: (
        <ul className="list-unstyled list-style">
          {[
            ['Learning resources:', 'Tutoring, writing/Math centers, and supplemental instruction.'],
            ['Accessibility services:', 'Academic accommodations and assistive technologies.'],
            ['Well-being:', 'Counseling, health services, and wellness programming.'],
          ].map(([k, v], i) => (
            <li key={`support-${i}`} style={liRow}>
              <i className="fa-solid fa-circle-arrow-right" style={icon} />
              <div style={kv}><span style={keyText}>{k}</span><span style={valText}>{v}</span></div>
            </li>
          ))}
        </ul>
      ),
    },
    {
      Que: 'Research & Experiential Learning',
      Answer: (
        <ul className="list-unstyled list-style">
          {[
            ['Undergrad research:', 'Join faculty projects, labs, and presentations at symposia.'],
            ['Experiential:', 'Internships, co-ops, service learning, and field placements.'],
            ['Compliance:', 'IRB processes for human-subjects research and responsible conduct training.'],
          ].map(([k, v], i) => (
            <li key={`research-${i}`} style={liRow}>
              <i className="fa-solid fa-circle-arrow-right" style={icon} />
              <div style={kv}><span style={keyText}>{k}</span><span style={valText}>{v}</span></div>
            </li>
          ))}
        </ul>
      ),
    },
    {
      Que: 'Academic Policies',
      Answer: (
        <ul className="list-unstyled list-style">
          {[
            ['SAP & standing:', 'Satisfactory Academic Progress and probation/appeal procedures.'],
            ['Attendance & grading:', 'Syllabi govern expectations; midterm and final grade posting.'],
            ['Integrity:', 'Academic honesty policy, reporting, and sanctions.'],
          ].map(([k, v], i) => (
            <li key={`policies-${i}`} style={liRow}>
              <i className="fa-solid fa-circle-arrow-right" style={icon} />
              <div style={kv}><span style={keyText}>{k}</span><span style={valText}>{v}</span></div>
            </li>
          ))}
        </ul>
      ),
    },
    {
      Que: 'Libraries & Learning Tech',
      Answer: (
        <ul className="list-unstyled list-style">
          {[
            ['Library access:', 'Print and digital collections, interlibrary loan, and research help.'],
            ['Learning platform:', 'Course materials and submissions via the LMS.'],
            ['Tech services:', 'ID card, labs, software, and printing resources.'],
          ].map(([k, v], i) => (
            <li key={`library-${i}`} style={liRow}>
              <i className="fa-solid fa-circle-arrow-right" style={icon} />
              <div style={kv}><span style={keyText}>{k}</span><span style={valText}>{v}</span></div>
            </li>
          ))}
        </ul>
      ),
    },
    {
      Que: 'Campus Life & Housing',
      Answer: (
        <ul className="list-unstyled list-style">
          {[
            ['Housing & dining:', 'Residence halls, meal plans, and commuter resources.'],
            ['Engagement:', 'Student organizations, leadership, and recreation/fitness.'],
            ['Safety & Title IX:', 'Campus safety programs and reporting options.'],
          ].map(([k, v], i) => (
            <li key={`life-${i}`} style={liRow}>
              <i className="fa-solid fa-circle-arrow-right" style={icon} />
              <div style={kv}><span style={keyText}>{k}</span><span style={valText}>{v}</span></div>
            </li>
          ))}
        </ul>
      ),
    },
    {
      Que: 'Graduation & Careers',
      Answer: (
        <ul className="list-unstyled list-style">
          {[
            ['Apply to graduate:', 'Credit checks, application deadlines, and commencement info.'],
            ['Career services:', 'Resume reviews, mock interviews, job fairs, and employer networking.'],
            ['Alumni & records:', 'Transcripts, diplomas, and alumni engagement.'],
          ].map(([k, v], i) => (
            <li key={`grad-${i}`} style={liRow}>
              <i className="fa-solid fa-circle-arrow-right" style={icon} />
              <div style={kv}><span style={keyText}>{k}</span><span style={valText}>{v}</span></div>
            </li>
          ))}
        </ul>
      ),
    },
  ];

  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="Higher Education - GTS State University (GTSU)" />
            </div>

            <div className="department-details-content-box">
              <h4 ref={titleRef} className="department-details-title">Higher Education - GTS State University (GTSU)</h4>

              {/* Overview */}
              <p style={overviewText}>
                Academic programs, research opportunities, student support, and campus life resources that help GTSU
                students persist, graduate, and launch meaningful careers.
              </p>

              {/* Download buttons */}
              <div style={{ margin: '0 0 16px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <a
                  href="/guides/GTSStateUGraduateCatalog2025.pdf"
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    padding: '8px 16px',
                    fontSize: '14px',
                    color: '#e75934',
                    textDecoration: 'none',
                    border: '1px solid #e75934',
                    borderRadius: '6px',
                    transition: 'all 0.2s ease',
                    backgroundColor: 'transparent',
                    width: 'fit-content'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#e75934';
                    e.currentTarget.style.color = '#fff';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.color = '#e75934';
                  }}
                >
                  <i className="fa-solid fa-file-pdf" style={{ marginRight: '8px', fontSize: '14px' }} />
                  Download Graduate Catalog 2025–2026 (PDF)
                </a>
                <a
                  href="/guides/GTSacademic-transcripts-operating-procedure.pdf"
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    padding: '8px 16px',
                    fontSize: '14px',
                    color: '#e75934',
                    textDecoration: 'none',
                    border: '1px solid #e75934',
                    borderRadius: '6px',
                    transition: 'all 0.2s ease',
                    backgroundColor: 'transparent',
                    width: 'fit-content'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#e75934';
                    e.currentTarget.style.color = '#fff';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.color = '#e75934';
                  }}
                >
                  <i className="fa-solid fa-file-pdf" style={{ marginRight: '8px', fontSize: '14px' }} />
                  Download Academic Transcripts Operating Procedures (PDF)
                </a>
                <Link
                  to="/forms"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    padding: '8px 16px',
                    fontSize: '14px',
                    color: '#666',
                    textDecoration: 'none',
                    border: '1px solid #ddd',
                    borderRadius: '6px',
                    transition: 'all 0.2s ease',
                    backgroundColor: 'transparent',
                    width: 'fit-content'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#f5f5f5';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                >
                  Grad & Undergrad Admissions Forms (Online Forms)
                </Link>
              </div>
            </div>

            {/* Accordion */}
            <div className="accordian-box">
              {sections.map((item, index) => (
                <div className={`accordian-box-item ${Faq !== index && 'active'}`} key={index}>
                  <div className="accordian-title">
                    <h5>{item.Que}</h5>
                    <i
                      className="fa-solid fa-angle-right"
                      onClick={() => setFaq(index)}
                      role="button"
                      aria-label={`Toggle ${item.Que}`}
                    />
                  </div>

                  {Faq === index && (
                    <div className="accordian-content" style={{ display: 'block' }}>
                      {item.Answer}
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="department-details-policy-box">
              <h4>Our Commitment:</h4>
              <p>
                Deliver high-quality, affordable higher education for GTSU—expanding access, supporting diverse learners,
                and preparing graduates for leadership and lifelong success.
              </p>
            </div>

            <div>
              <Link to="/department/education">
                <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }} />
                Go Back
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default HigherEducation;
